import React from "react";
import bg from "./bg.jpg";
import "./Top.scss";

class Top extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    return (
      <div className="top">
        <div className="bg" style={{ backgroundImage: `url(${bg})` }} />
      </div>
    );
  }
}

export default Top;
